import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AccountDetails from '../../components/dashboard/AccountDetails';
import PasswordSettings from '../../components/dashboard/PasswordSettings';
import BankSettings from '../../components/dashboard/BankSettings';
import NotificationSettings from '../../components/dashboard/NotificationSettings';
const ProfilePage = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('details');

  const renderContent = () => {
    switch (activeTab) {
      case 'details':
        return <AccountDetails />;
      case 'password':
        return <PasswordSettings />;
      case 'bank':
        return <BankSettings />;
		 case 'notifications':
        return <NotificationSettings />;
      default:
        return <AccountDetails />;
		
    }
  };

  return (
    <div className="dashboard-page profile-page-narrow-content">
      {/* DÜZELTME: Varsayılan değerler kaldırıldı */}
      <h1>{t('dashboard_profile')}</h1>
      <div className="profile-layout">
        <aside className="profile-sidebar">
          <nav>
            <button onClick={() => setActiveTab('details')} className={activeTab === 'details' ? 'active' : ''}>{t('account_details')}</button>
            <button onClick={() => setActiveTab('password')} className={activeTab === 'password' ? 'active' : ''}>{t('password')}</button>
            <button onClick={() => setActiveTab('bank')} className={activeTab === 'bank' ? 'active' : ''}>{t('bank_accounts')}</button>
			 <button onClick={() => setActiveTab('notifications')} className={activeTab === 'notifications' ? 'active' : ''}>{t('notification_settings')}</button>
          </nav>
        </aside>
         
        <main className="profile-content">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default ProfilePage;